<div class="pedido-nao-liberado-card-info-lucro-liquido-abaixo card card-warning">
    <div class="card-header">
        <p class="card-title mb-0">
            <i class="fas fa-exclamation-triangle"></i> Análise de Custos Necessária
        </p>
    </div>

    <ul class="list-group list-group-flush list-group-vertical">
        <li class="list-group-item">
            <span class="list-group-item-title">
                Motivo da Não Liberação
            </span>
            <span class="list-group-item-value">
                Este {{tipoVenda | pedidoTipoVendaSinonimo}} não foi liberado por que necessita de uma análise de custos
            </span>
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Não Liberado em
            </span>
            <span class="list-group-item-value">
                {{dataNaoLiberado | date: 'dd/MM/yyyy'}} às {{dataNaoLiberado | date: 'HH:mm'}}
            </span>
        </li>

        <ng-template [ngIf]="config.canShowDRP && drp">
            <li class="list-group-item">
                <span class="list-group-item-title">
                    Valor do lucro líquido
                </span>
                <span class="list-group-item-value">
                    {{drp.valorLucroLiquidoNaoLiberado | currencyFormat: 1:2:2}}
                </span>
            </li>
            <li class="list-group-item">
                <span class="list-group-item-title">
                    Lucro líquido mínimo permitido
                </span>
                <span class="list-group-item-value">
                    {{drp.percLucroLiquidoMinimoNaoLiberado | decimalFormat: 1:2:2}}%
                </span>
            </li>
            <li class="list-group-item">
                <span class="list-group-item-title">
                    Lucro líquido
                </span>
                <span class="list-group-item-value">
                    <!-- Lucro Líquido-->
                    <sgt-pedido-drp-lucro-liquido-badge
                        [percLucroLiquido]="drp.percLucroLiquidoNaoLiberado"
                        [percLucroLiquidoAbaixo]="true">
                    </sgt-pedido-drp-lucro-liquido-badge>
                </span>
            </li>
        </ng-template>

        <ng-template [ngIf]="config.canShowQV && drp">
            <li class="list-group-item">
                <span class="list-group-item-title">
                    Qualidade de Valor (QV)
                </span>
                <span class="list-group-item-value">
                    <!-- Escala do Grupo de Rentabilidade -->
                    <sgt-escala-rentabilidade
                        [id]="drp.escalaGrupoRentabilidade"
                        [showText]="true">
                    </sgt-escala-rentabilidade>
                </span>
            </li>
        </ng-template>
    </ul>
</div>
